export default "__VITE_ASSET__CEMRy5uf__"